// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panorama-view .ivu-modal-body{padding:0}.panorama-view .research_course_iframe{width:100%;height:99%;border:none}", ""]);
// Exports
module.exports = exports;
